// extracted by mini-css-extract-plugin
module.exports = {"container":"_2K5ZfvoH_mEHSM1a8bGLgp"};